import type { Langue } from './langues';

/**
 * Filiales PRODEVAL (design du 21/10/2026). Les codes et villes sont à confirmer par la DSI.
 * Libellés : clés `filiale.<code>` et `pays.<pays>` du dictionnaire.
 */
export interface Filiale {
  code: string;          // code utilisé dans les références (OT-FR01-2026-008841)
  pays: string;          // ISO 3166-1 alpha-2 (drapeau)
  ville: string;         // site principal
  devise: string;        // ISO 4217
  fuseau: string;        // IANA
  langue: Langue;        // langue par défaut des utilisateurs de la filiale
  locale: string;        // formats des enregistrements de la filiale (Intl)
}

export const FILIALES: readonly Filiale[] = [
  { code: 'FR01', pays: 'FR', ville: 'Valence', devise: 'EUR', fuseau: 'Europe/Paris', langue: 'fr', locale: 'fr-FR' },
  { code: 'IT01', pays: 'IT', ville: 'Milano', devise: 'EUR', fuseau: 'Europe/Rome', langue: 'it', locale: 'it-IT' },
  { code: 'ES01', pays: 'ES', ville: 'Madrid', devise: 'EUR', fuseau: 'Europe/Madrid', langue: 'es', locale: 'es-ES' },
  { code: 'DE01', pays: 'DE', ville: 'Berlin', devise: 'EUR', fuseau: 'Europe/Berlin', langue: 'de', locale: 'de-DE' },
  { code: 'US01', pays: 'US', ville: 'Chicago', devise: 'USD', fuseau: 'America/Chicago', langue: 'en', locale: 'en-US' },
  { code: 'CA01', pays: 'CA', ville: 'Montréal', devise: 'CAD', fuseau: 'America/Toronto', langue: 'fr', locale: 'fr-CA' },
  { code: 'BR01', pays: 'BR', ville: 'São Paulo', devise: 'BRL', fuseau: 'America/Sao_Paulo', langue: 'pt', locale: 'pt-BR' },
  { code: 'CZ01', pays: 'CZ', ville: 'Praha', devise: 'CZK', fuseau: 'Europe/Prague', langue: 'en', locale: 'cs-CZ' },
];

/**
 * Coordonnées (degrés décimaux) de la ville principale de chaque filiale : météo de l'accueil quand la position de
 * l'utilisateur n'est pas connue. Hors du référentiel en base (dim.filiale) tant que les cartes n'existent pas.
 */
export const COORDONNEES_FILIALES: Readonly<Record<string, { lat: number; lon: number }>> = {
  FR01: { lat: 44.93, lon: 4.89 },
  IT01: { lat: 45.46, lon: 9.19 },
  ES01: { lat: 40.42, lon: -3.7 },
  DE01: { lat: 52.52, lon: 13.4 },
  US01: { lat: 41.88, lon: -87.63 },
  CA01: { lat: 45.5, lon: -73.57 },
  BR01: { lat: -23.55, lon: -46.63 },
  CZ01: { lat: 50.08, lon: 14.44 },
};

/** Code spécial : toutes les filiales autorisées de l'utilisateur (globe dans l'en-tête). */
export const TOUTES_FILIALES = 'ALL';

export function filiale(code: string): Filiale | undefined {
  return FILIALES.find((f) => f.code === code);
}
